;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "EquityCheckout",
  props: ["xcsrftoken", "callback_url", "status_api_url", "gateway_id", "request_type"],
  data: function data() {
    return {
      currency: null,
      logo: null,
      invoice_amount: null,
      agent_fee: 0,
      fee: 0,
      invoice_number: null,
      url: null,
      total_amount: 0,
      account_number: null,
      otp: null,
      loading: false,
      authorizing: false,
      proceedToAuthorize: false,
      authorized: false,
      account_input_has_error: false,
      otp_input_has_error: false,
      idno_input_has_error: false,
      id_number: null,
      base_url: "",
      gateway: null,
      error_message: null,
      success_message: null
    };
  },


  mounted: function mounted() {
    var _this = this;

    $("#equityCheckoutModal").on("hidden.bs.modal", function () {
      _this.proceedToAuthorize = false;
      _this.account_number = null;
      _this.id_number = null;
      _this.otp = null;
      _this.loading = false;
      _this.authorizing = false;
      _this.authorized = false;
      _this.error_message = null;
      _this.destroyTimer();
    });
    this.invoice_number = this.$attrs["invoice_no"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.logo = this.$attrs["logo"];
    this.base_url = this.$attrs["base_url"];
    this.gateway = this.$attrs["gid"];
    this.id_number = this.$attrs["id_number"];
    this.set_total_amount();
    $("#equityCheckoutModal").on("shown.bs.modal", function () {
      _this.proceedToAuthorize = false;
      _this.account_number = null;
      _this.otp = null;
      _this.loading = false;
      _this.authorizing = false;
      _this.authorized = false;
      _this.error_message = null;
    });
  },
  computed: {
    account_has_no_error: function account_has_no_error() {
      if (this.account_number) {
        if (this.account_number.match(/^\d+$/)) {
          this.account_input_has_error = true;
          return true;
        } else {
          this.account_input_has_error = false;
          return false;
        }
      } else {
        return false;
      }
    },
    id_has_no_error: function id_has_no_error() {
      if (this.id_number) {
        if (this.id_number.match(/^\d+$/)) {
          this.idno_input_has_error = true;
          return true;
        } else {
          this.idno_input_has_error = false;
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    reset_errors: function reset_errors() {
      this.error_message = this.success_message = null;
    },
    otp_has_error: function otp_has_error() {
      if (this.otp && !this.otp.match(/^\d+$/)) {
        this.otp_input_has_error = true;
      } else {
        this.otp_input_has_error = false;
      }
    },
    destroyTimer: function destroyTimer() {
      if (this.$refs.timer) {
        this.$refs.timer.destroyTimer();
      }
    },

    set_total_amount: function set_total_amount() {
      this.total_amount = parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee);
    },
    get_otp: function get_otp() {
      var _this2 = this;

      this.loading = true;
      this.error_message = null;
      this.success_message = null;
      var urlIs = this.base_url + "/api/payment/equity/checkout";
      var api_headers = {
        Authorization: ""
      };
      var params = {
        account_number: this.account_number,
        gateway_id: this.gateway,
        amount: this.total_amount,
        invoice_number: this.invoice_number,
        id_number: this.id_number
      };
      Vue.axios.post(urlIs, params, {
        headers: api_headers
      }).then(function (v) {
        _this2.loading = false;
        _this2.proceedToAuthorize = true;
      }).catch(function (v) {
        _this2.loading = false;
        _this2.account_number = null;
        _this2.error_message = "Processing failed ! Try again later";
      });
    },

    authorize_payment: function authorize_payment() {
      var _this3 = this;

      this.authorizing = true;
      this.error_message = null;
      this.success_message = null;
      var urlIs = this.base_url + "/api/payment/equity/checkout/authorize";
      var api_headers = {
        Authorization: ""
      };
      var params = {
        otp: this.otp,
        gateway_id: this.gateway,
        invoice_number: this.invoice_number
      };
      Vue.axios.post(urlIs, params, {
        headers: api_headers
      }).then(function (v) {
        _this3.authorizing = false;
        _this3.authorized = true;
        _this3.otp = null;
        _this3.error_message = null;
        _this3.success_message = "Transaction was Successful. Redirecting you in 2 sec(s), please wait...";

        setInterval(function () {
          _this3.redirect();
        }, 2500);
      }).catch(function (v) {
        _this3.success_message = null;
        _this3.error_message = "Processing failed ! Try again later";
        _this3.account_number = null;
        _this3.authorized = false;
        _this3.authorizing = false;
        _this3.otp = null;
      });
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"equityCheckoutModal","tabindex":"-1","role":"dialog","aria-labelledby":"equityCheckoutModallLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',[(_vm.error_message)?_c('p',{staticClass:"alert alert-danger"},[_vm._v("\n                        "+_vm._s(_vm.error_message)+"\n                      ")]):_vm._e(),_vm._v(" "),(_vm.success_message)?_c('p',{staticClass:"alert alert-success"},[_vm._v("\n                        "+_vm._s(_vm.success_message)+"\n                      ")]):_vm._e(),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("AccountNumber\n                        "),(!_vm.account_has_no_error)?_c('span',{staticClass:"error"},[_vm._v("Numbers only*")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account_number),expression:"account_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter your Equity Account Number","pattern":"\\d*","maxlength":"14","required":""},domProps:{"value":(_vm.account_number)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.account_number=$event.target.value},function($event){_vm.reset_errors()}]}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"email"}},[_vm._v("ID Number\n                        "),(!_vm.id_has_no_error)?_c('span',{staticClass:"error"},[_vm._v("Numbers only*")]):_vm._e()]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.id_number),expression:"id_number"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter your ID Number","pattern":"\\d*","maxlength":"14","required":""},domProps:{"value":(_vm.id_number)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.id_number=$event.target.value},function($event){_vm.reset_errors()}]}}),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.otp_input_has_error && _vm.proceedToAuthorize)?_c('label',{attrs:{"for":"email"}},[_vm._v("OTP (One Time Pin)\n                        "),(_vm.otp && !_vm.account_has_no_error)?_c('span',{staticClass:"error"},[_vm._v("\n                          Numbers only*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.proceedToAuthorize)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otp),expression:"otp"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Enter your one time pin","required":""},domProps:{"value":(_vm.otp)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.otp=$event.target.value},function($event){_vm.reset_errors()}]}}):_vm._e()])]),_vm._v(" "),(!_vm.proceedToAuthorize)?_c('div',{staticClass:"\n                      card-footer\n                      d-flex\n                      justify-content-end\n                      align-items-center\n                    "},[_c('a',{staticClass:"pull-left btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")]),_vm._v(" "),(!_vm.loading && !_vm.account_has_no_error)?_c('input',{staticClass:"btn btn-primary not-allowed",attrs:{"type":"submit","data-toggle":"modal","value":"Proceed","disabled":""}}):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.account_has_no_error)?_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.get_otp}},[_vm._v("Proceed")]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"javascript:void(0)"}},[_vm._v("Please wait ...")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.proceedToAuthorize)?_c('div',{staticClass:"\n                      card-footer\n                      d-flex\n                      justify-content-end\n                      align-items-center\n                    "},[_c('a',{staticClass:"pull-left btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Cancel")]),_vm._v(" "),(
                        _vm.otp &&
                        !_vm.authorized &&
                        !_vm.otp_input_has_error &&
                        !_vm.authorizing
                      )?_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.authorize_payment}},[_vm._v("Authorize Payment")]):_vm._e(),_vm._v(" "),(_vm.authorizing)?_c('a',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"href":"javascript:void(0)"}},[_vm._v("Authorizing...")]):_vm._e(),_vm._v(" "),(_vm.authorized)?_c('complete-button',{ref:"timer",attrs:{"gateway":"equitycheckout","poll_external":"false","gateway_id":_vm.gateway_id,"status_api_url":_vm.status_api_url,"invoice_no":_vm.invoice_number,"callback_url":_vm.callback_url}}):_vm._e()],1):_vm._e()])])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay Using Equity Account")])])}]
__vue__options__._scopeId = "data-v-7e282b89"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7e282b89", __vue__options__)
  } else {
    hotAPI.reload("data-v-7e282b89", __vue__options__)
  }
})()}